export default __webpack_public_path__ + "static/government_b.90aa5fcf16f1b9fa0337450d19404ad2.png";